import defaultRouteSettings from "./default";

const routes = defaultRouteSettings.routes;

routes.forEach((route) => {

});


export default {
    routes,
    beforeEach: defaultRouteSettings.beforeEach, 
};
